import { takeEvery, call, put, select } from 'typed-redux-saga'
import { errorHandler, notifyMessageCreator, gridSlice } from 'Modules'
import { Deserialize } from 'cerialize'
import { RequestParams, ResponseCatalog } from 'Models'
import {
	CallNS,
	callSlice,
	CallModel,
	CallStatus,
	Status,
	callApi,
	callSelectors,
	PotentialClientStatus,
} from 'Pages/coliseum'

function* getAll(action: CallNS.GetAll) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(callSlice.actions.clearAll())
		}
		const data = yield* call(callApi.getAll, requestParams)
		const calls = new ResponseCatalog<CallModel>(data)
		if (!clear) {
			const oldData = yield* select(callSelectors.getEntries)
			calls.entries = oldData.concat(data.entries)
		}
		yield* put(callSlice.actions.setAll(calls))
		yield* put(callSlice.actions.setRequestParams({ params: requestParams }))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* createOne(action: CallNS.CreateOne) {
	try {
		yield* call(callApi.createOne, action.payload)
		yield* put(callSlice.actions.getAll({ params: new RequestParams(), clear: true }))
		yield* call(notifyMessageCreator, 'coliseum.callback_create.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* updateOne(action: CallNS.UpdateOne) {
	try {
		const { id, data, callback } = action.payload
		yield* call(callApi.updateOne, id, data)
		yield* put(callSlice.actions.getAll({ params: new RequestParams(), clear: true }))
		yield* call(notifyMessageCreator, 'coliseum.callback_update.success')
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getAllCallStatus() {
	try {
		const res = yield* call(callApi.getAllCallStatus)
		const callStatuses = res.map((status): CallStatus => Deserialize(status, CallStatus))
		yield* put(callSlice.actions.setAllCallStatus(callStatuses))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getAllPotentialClientStatus() {
	try {
		const res = yield* call(callApi.getAllPotentialClientStatus)
		const potentialClientStatuses = res.map(
			(status): PotentialClientStatus => Deserialize(status, PotentialClientStatus)
		)
		yield* put(callSlice.actions.setAllPotentialClientStatus(potentialClientStatuses))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getAllStatus() {
	try {
		const res = yield* call(callApi.getAllStatus)
		const statuses = res.map((status): Status => Deserialize(status, Status))
		yield* put(callSlice.actions.setAllStatus(statuses))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* callSaga() {
	yield* takeEvery(callSlice.actions.getAll, getAll)
	yield* takeEvery(callSlice.actions.createOne, createOne)
	yield* takeEvery(callSlice.actions.updateOne, updateOne)
	yield* takeEvery(callSlice.actions.getAllCallStatus, getAllCallStatus)
	yield* takeEvery(callSlice.actions.getAllStatus, getAllStatus)
	yield* takeEvery(callSlice.actions.getAllPotentialClientStatus, getAllPotentialClientStatus)
}
